// extracted by mini-css-extract-plugin
export var leftAlign = "_1e-2";
export var popper = "_1e-0";
export var subtitle = "_1e-1";